export default __webpack_public_path__ + "static/media/about.eba32f95.jpg";